import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ClinicStatus } from '../../models/clinic-status.model';
import { ClinicStatusService } from '../../services/clinic-status.service';

@Component({
  selector: 'app-clinic-status-edit',
  templateUrl: './clinic-status-edit.component.html',
  styleUrls: ['./clinic-status-edit.component.css']
})
export class ClinicStatusEditComponent implements OnInit {
  initialList: ClinicStatus[];
  clinicStatusList: ClinicStatus[];
  clinicStatus: ClinicStatus;

  isValid: boolean;

  constructor(private route: ActivatedRoute, private clinicStatusService: ClinicStatusService) { }

  ngOnInit() {
    this.clinicStatusService.getClinicStatusList()
      .subscribe(clinicStatusList => {
        this.clinicStatusList = clinicStatusList;
        this.initialList = clinicStatusList;
      });

    this.isValid = true;

    const id = Number(this.route.snapshot.paramMap.get("id"));

    this.clinicStatusService.getClinicStatus(id).subscribe(status => {
      this.clinicStatus = status;
    });
  }

  update() {
    this.isValid = this.clinicStatus.consultation !== 2 && this.clinicStatus.electricity !== 2 &&
      this.clinicStatus.waterSupply !== 2 && this.clinicStatus.phone !== 2;

    if (this.isValid)
      this.clinicStatusService.updateStatus(this.clinicStatus);

  }
}
